$('.single-slider .slide-list').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  arrows: true,
  slidesToScroll: 1,
  adaptiveHeight: true
});

$(".announcement_close_btn").click(function(){
  $(".announcement-bar-section").addClass("announcement_active");
});


  $(".tab-container .tab_content").hide();
  $('.tab-container').each(function(k,v){
    $(v).find('.tab_content:first').show();
  });
  
    / if in tab mode /
    $("ul.tabs li").click(function() {
      var parent = $(this).parents('.tab-container');
  
      $(parent).find(".tab_content").hide();
      var activeTab = $(this).attr("rel");
      $(parent).find("#"+activeTab).fadeIn();
  
      $(parent).find("ul.tabs li").removeClass("active");
      $(this).addClass("active");
  
      $(parent).find(".tab_drawer_heading").removeClass("d_active");
      $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
      $('.product-list').slick('refresh');
  
    });
    / if in drawer mode /
    $(".tab_drawer_heading").click(function() {
      var parent = $(this).parents('.tab-container');
  
      $(parent).find(".tab_content").hide();
      var d_activeTab = $(this).attr("rel");
      $(parent).find("#"+d_activeTab).fadeIn();
  
      $(parent).find(".tab_drawer_heading").removeClass("d_active");
      $(this).addClass("d_active");
  
      $(parent).find("ul.tabs li").removeClass("active");
      $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
      $('.product-list').slick('refresh');
    });
      $( document ).ready(function() {
        
$('.featured-products-slider .product-list').slick({
  dots: false,
   arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
   responsive: [
     {
          breakpoint: 1400,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
})
  $('.products-slider-five .product-list').slick({
  dots: false,
   arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
   responsive: [
     {
          breakpoint: 1400,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
})

        $(".select_tabs").click(function() {
  var is_open = $(this).hasClass("open");
  if (is_open) {
    $(this).removeClass("open");
  } else {
    $(this).addClass("open");
  }
});

$(".select_tabs li").click(function() {

  var selected_value = $(this).html();
  var first_li = $(".select_tabs li:first-child").html();

  $(".select_tabs li:first-child").html(selected_value);
  $(this).html(first_li);

});

$(document).mouseup(function(event) {

  var target = event.target;
  var select = $(".select_tabs");

  if (!select.is(target)
 && select.has(target).length === 0) {
    select.removeClass("open");
  }

});
});


$('.template-index .custom_featured_col .custom_feature_grid').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
   responsive: [
     {
          breakpoint: 1400,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
})

$('.MainProduct .thumbnail-list ').slick({
  dots: false,
  infinite: true,
  speed: 300,
  arrows:true,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});



